import React, { useEffect, useState } from 'react'


const RadioWrapper = ({ filtersId, day, item, setFilters, mealName, isChecked, anyMeal }) => {

  const  [ checked, setChecked ] = useState(false)
  const radioUniqueID = `${filtersId}-${mealName}-${day}`

  const onChange = () => {
    setFilters(
      mealName,
      day,
      !checked,
    )
    setChecked(!checked)
  }

  useEffect(() => {
    if ( checked !== isChecked ) {
      setChecked(isChecked)
    }
  }, [isChecked])

  return (
    <div className={`c-searchRadioButton h-radioButton ${anyMeal ? 'is-disabled' : ''}`}>
      <label className="h-radioButton__label">
        <input className="h-radioButton__input" type="checkbox" checked={checked} onChange={onChange} />
        <div className="h-radioButton__icon" />
      </label>
    </div>
  )
}


export default RadioWrapper